import React, { useState } from "react";
import { APP_ID } from "../../utils/constants";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Paper,
  Stack,
} from "@mui/material";
import { getErrorResponse } from "../../utils/util";
import useTermsConditions from "../../hooks/userTermsConditions";
import parse from "html-react-parser";

const TermsConditions = ({ onContinue }) => {
  const [accepted, setAccepted] = useState(false);
  const { data, isLoading, isError, error } = useTermsConditions(APP_ID);

  if (isLoading) {
    return <CircularProgress />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, maxWidth: 600, mx: "auto" }}>
      <Box
        sx={{
          maxHeight: 300,
          overflowY: "auto",
        }}
      >
        {parse(data.terms)}
      </Box>

      <Stack direction="column" spacing={2} alignItems="center" mt={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
            />
          }
          label="I accept the Terms and Conditions"
        />
        <Button
          onClick={() => onContinue && onContinue()}
          variant="contained"
          color="primary"
          disabled={!accepted}
        >
          Continue
        </Button>
      </Stack>
    </Paper>
  );
};

export default TermsConditions;
